import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["logo", "navigation", "search"]

  initialize() {
    this.scheduleUpdate = this.scheduleUpdate.bind(this)
    this.update = this.update.bind(this)
  }

  connect() {
    window.addEventListener("load", this.update)
    window.addEventListener("scroll", this.scheduleUpdate, { passive: true })
    window.addEventListener("resize", this.scheduleUpdate)
    this.update()
  }

  disconnect() {
    window.removeEventListener("load", this.update)
    window.removeEventListener("scroll", this.scheduleUpdate)
    window.removeEventListener("resize", this.scheduleUpdate)

    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame)
    }

    document.documentElement.style.removeProperty("--website-header-offset")
  }

  openCart(event) {
    event.currentTarget.classList.add("open")
  }

  closeCart(event) {
    event.currentTarget.classList.remove("open")
  }

  submitSearch(event) {
    if (!this.searchTarget.value.trim()) event.preventDefault()
  }

  clearSearch() {
    this.searchTarget.value = ""
    this.searchTarget.focus()
    this.searchTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  closeSearch() {
    if (this.hasSearchTarget) this.searchTarget.blur()
  }

  scheduleUpdate() {
    if (this.animationFrame) return

    this.animationFrame = requestAnimationFrame(() => {
      this.update()
      this.animationFrame = null
    })
  }

  update() {
    this.updateFill()
    this.updateMobileVisibility()
    this.updateNavigationOverflow()
    this.updateRibbonOffset()
    this.updateHeaderOffset()
  }

  updateFill() {
    if (!document.body.classList.contains("has_background")) return

    const fill = window.scrollY > this.ribbonHeight
    const alwaysFill = this.element.classList.contains("always-fill")

    this.element.classList.toggle("fill", fill || alwaysFill)

    if ((fill || alwaysFill) && this.hasSearchTarget && this.element.querySelector(":scope > .catalog-search")?.contains(document.activeElement)) {
      document.activeElement.blur()
    }

    if (this.hasLogoTarget) {
      this.logoTarget.src = fill || alwaysFill
        ? this.logoTarget.dataset.blackLogo
        : this.logoTarget.dataset.whiteLogo
    }
  }

  updateMobileVisibility() {
    if (document.body.classList.contains("with_mobile_universes")) {
      this.element.classList.toggle("visible", window.scrollY > 330)
    }
  }

  updateNavigationOverflow() {
    if (!this.hasNavigationTarget) return

    const list = this.navigationTarget.querySelector("ul")
    const itemWidth = Array.from(list.querySelectorAll(":scope > li:not(#bottom-line)"))
      .reduce((width, item) => width + item.offsetWidth, 0)

    list.classList.toggle("scroll", this.navigationTarget.clientWidth < itemWidth)
  }

  updateRibbonOffset() {
    const ribbon = document.getElementById("ribbon")

    if (ribbon) {
      this.element.style.marginTop = `${ribbon.getBoundingClientRect().height}px`
    } else {
      this.element.style.removeProperty("margin-top")
    }
  }

  updateHeaderOffset() {
    const offset = this.element.getBoundingClientRect().bottom + 16
    document.documentElement.style.setProperty("--website-header-offset", `${offset}px`)
  }

  get ribbonHeight() {
    const ribbon = document.getElementById("ribbon")

    return ribbon?.getBoundingClientRect().height || 0
  }
}
